import React, { useEffect, useRef, useState } from "react";
import {
  IconActionWhite,
  IconCloseSmall,
  IconCloseSmallBlue,
  IconCorporateFareBlue,
  IconDoorBack,
  IconDoorBackBlue,
  IconKeyboardArrowLeftBlue,
  IconKeyboardArrowRight,
  IconKeyboardArrowRightBlue,
  IconMoreHoriz,
  IconMoreHorizBlue,
} from "assets/svg";
import { Link, NavLink, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "store/store";
import { cleanData } from "reducers/authSlice";
import { menuBuyer } from "./MenuBuyer";
import { useCommonContext } from "contexts/CommonContext";

const HeaderTopSeller = () => {
  const dispatch = useDispatch<AppDispatch>();
  const navigate = useNavigate();
  const [openMenuBox, setOpenMenuBox] = useState(false);
  const { userData } = useSelector((state: RootState) => state.auth);

  const {
    headerTitle,
    headerTitleMobile,
    openMenuBoxMobile,
    setOpenMenuBoxMobile,
  } = useCommonContext();

  const ref = useRef<HTMLDivElement>(null);
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (ref.current && !ref.current.contains(event.target as Node)) {
        setOpenMenuBox(false);
        setOpenMenuBoxMobile(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const logout = () => {
    dispatch(cleanData());
    navigate("/");
  };

  return (
    <div
      ref={ref}
      className="flex w-full h-[50px] md:h-[80px] px-[8px] py-[8px] pl-[8px] md:px-[15px] md:py-[15px] md:pl-[40px] justify-end items-center gap-[10px] md:gap-[20px] border-b border-b-primary bg-white relative rounded-t-[12px]"
    >
      <div
        className="md:hidden flex w-[34px] h-[34px] p-[10px] flex-col justify-center items-center gap-[10px] rounded-[14px] bg-primary-light"
        onClick={() => navigate(-1)}
      >
        <IconKeyboardArrowLeftBlue className="w-[24px] h-[24px] shrink-0 aspect-[1/1]" />
      </div>
      {/*Title*/}
      {headerTitleMobile ? (
        <div className="min-w-0 flex-[1_0_0] truncate whitespace-nowrap text-center font-['Noto_Sans_JP'] text-[18px] font-bold not-italic leading-[160%] text-black md:hidden">
          {headerTitleMobile}
        </div>
      ) : (
        <div className="min-w-0 flex-[1_0_0] truncate whitespace-nowrap text-center font-['Noto_Sans_JP'] text-[18px] font-bold not-italic leading-[160%] text-black md:hidden">
          {headerTitle}
        </div>
      )}
      <div className="hidden min-w-0 flex-1 truncate whitespace-nowrap text-black font-['Noto Sans JP'] text-[20px] font-bold not-italic leading-[160%] md:block md:text-left lg:text-[28px]">
        {headerTitle}
      </div>
      {/*Account*/}
      <div className="hidden shrink-0 items-center gap-[10px] md:flex">
        <div
          className="max-w-[140px] truncate text-left font-['Noto Sans JP'] text-[14px] font-normal not-italic leading-[160%] text-black xl:max-w-[220px]"
          title={userData.company_name}
        >
          {userData.company_name}
        </div>
        <div
          className="flex w-[34px] h-[34px] flex-col justify-center items-center gap-[10px] rounded-[14px] bg-primary-light"
          onClick={() => setOpenMenuBox(!openMenuBox)}
        >
          {openMenuBox ? (
            <IconCloseSmallBlue className="w-[24px] h-[24px] aspect-[1/1]" />
          ) : (
            <IconMoreHorizBlue className="w-[24px] h-[24px] aspect-[1/1]" />
          )}
        </div>
      </div>
      {/*Button*/}
      <Link
        to="/buyer/product/list"
        className="hidden h-[50px] w-[140px] shrink-0 cursor-pointer items-center justify-center gap-[7px] rounded-[6px] bg-primary px-[20px] py-[7px] lg:flex"
      >
        <IconActionWhite className="w-[24px] h-[24px] shrink-0 aspect-[1/1]" />
        <div className="text-white text-center font-['Noto Sans JP'] text-[16px] not-italic font-bold leading-[160%]">
          検索する
        </div>
      </Link>
      {/*Menu (Mobile)*/}
      <div
        className="md:hidden flex w-[34px] h-[34px] flex-col justify-center items-center gap-[10px] rounded-[14px] bg-primary"
        onClick={() => setOpenMenuBoxMobile(!openMenuBoxMobile)}
      >
        <IconMoreHoriz className="w-[24px] h-[24px] shrink-0 aspect-[1/1]" />
      </div>
      {/*Menu Box*/}
      {openMenuBox && (
        <div className="hidden md:flex w-[200px] px-[20px] py-[10px] flex-col justify-center items-center absolute right-[175px] bottom-[-90px] rounded-[14px] bg-primary-light z-[9]">
          {/*Nav Item*/}
          <div className="h-[41px] flex py-[10px] items-center gap-[5px] self-stretch border-b border-b-white">
            <IconCorporateFareBlue className="w-[20px] h-[20px] aspect-[1/1]" />
            <Link
              to="/buyer/information"
              className="h-[21px] flex-[1_0_0] text-primary font-['Noto Sans JP'] text-[13px] not-italic font-bold leading-[160%] cursor-pointer"
            >
              登録情報の管理
            </Link>
            <IconKeyboardArrowRightBlue className="w-[20px] h-[20px] aspect-[1/1]" />
          </div>
          {/*Nav Item*/}
          <div className="h-[41px] flex py-[10px] items-center gap-[5px] self-stretch">
            <IconDoorBackBlue className="w-[20px] h-[20px] aspect-[1/1]" />
            <div
              onClick={logout}
              className="h-[21px] flex-[1_0_0] text-primary font-['Noto Sans JP'] text-[13px] not-italic font-bold leading-[160%] cursor-pointer"
            >
              ログアウト
            </div>
            <IconKeyboardArrowRightBlue className="w-[20px] h-[20px] aspect-[1/1]" />
          </div>
        </div>
      )}
      {/*Menu Box (Mobile)*/}
      {openMenuBoxMobile && (
        <div className="md:hidden w-full flex pb-[20px] flex-col items-end gap-[5px] absolute left-0 top-0 rounded-b-[12px] bg-primary z-[99]">
          {/*Menu HeaderTop*/}
          <div className="flex h-[50px] p-[8px] justify-center items-center gap-[10px] self-stretch">
            <div className="flex w-[34px] h-[34px] p-[10px] flex-col justify-center items-center gap-[10px] rounded-[14px] bg-primary"></div>
            {/*Title*/}
            <div className="flex-[1_0_0] text-white text-center font-['Noto Sans JP'] text-[18px] not-italic font-bold leading-[160%]">
              メニュー
            </div>
            {/*Menu*/}
            <div
              className="md:hidden flex w-[34px] h-[34px] flex-col justify-center items-center gap-[10px] rounded-[14px] bg-[#103E75]"
              onClick={() => setOpenMenuBoxMobile(false)}
            >
              <IconCloseSmall className="w-[24px] h-[24px] shrink-0 aspect-[1/1]" />
            </div>
          </div>
          {/*Menu Contents*/}
          <div className="flex px-[15px] flex-col items-start gap-[15px] self-stretch">
            {/*Sp Nav*/}
            <div className="flex w-full flex-col items-start border-t border-primary-medium">
              {menuBuyer.map((item) => (
                <NavLink
                  key={item.to}
                  to={item.to}
                  className="flex min-h-[50px] py-[10px] items-center gap-[10px] self-stretch border-b border-primary-medium bg-primary"
                >
                  <div className="w-[24px] h-[24px] aspect-[1/1]">
                    {item.icon}
                  </div>
                  <div className="flex-[1_0_0] text-white font-['Noto Sans JP'] text-[14px] not-italic font-bold leading-[160%]">
                    {item.label}
                  </div>
                  <IconKeyboardArrowRight className="w-[20px] h-[20px] aspect-[1/1]" />
                </NavLink>
              ))}
            </div>
            {/*Button Wrap*/}
            <div className="flex px-5 flex-col items-start gap-[10px] self-stretch">
              <div
                className="flex h-10 justify-center items-center gap-[5px] self-stretch rounded-[6px] bg-[#103E75]"
                onClick={logout}
              >
                <IconDoorBack className="w-[20px] h-[20px] aspect-[1/1]" />
                <div className="text-[12px] font-normal leading-[160%] text-white font-['Noto Sans JP'] cursor-pointer">
                  ログアウト
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default HeaderTopSeller;
